import React, { useEffect } from "react";
import { trackHowToPlayViewed } from '../../utils/activityTracker';
import useAchievements from '../../hooks/useAchievements';
import { useAuth } from '../../contexts/AuthContext';
import './SubnauticaCreaturesHowToPlay.scss';

const HowToPlayContent = () => (
  <>
    <h2 className="subnautica-creatures-how-to-play__title">How to Play</h2>
    <ul className="subnautica-creatures-how-to-play__list">
      <li className="subnautica-creatures-how-to-play__list-item">
        Try to guess the name of a <b>Subnautica creature</b> chosen at random!
      </li>
      <li className="subnautica-creatures-how-to-play__list-item">
        Each guess will be checked for matching <b>Size</b>, <b>Behavior</b>, <b>Biome</b>, <b>Diet</b>, and <b>Edible</b> status.
      </li>
      <li className="subnautica-creatures-how-to-play__list-item">
        <span className="subnautica-creatures-how-to-play__highlight-color subnautica-creatures-how-to-play__highlight-color--aqua">Aqua</span> means your guess matches the creature in that category.<br />
        <span className="subnautica-creatures-how-to-play__highlight-color subnautica-creatures-how-to-play__highlight-color--pink">Pink</span> means no match.
      </li>
      <li className="subnautica-creatures-how-to-play__list-item">
        Use the <b>Creature Directory</b> to browse creatures and filter by Size, Behavior, Biome, or Diet.
      </li>
      <li className="subnautica-creatures-how-to-play__list-item">
        Guess until you find the right creature and explore the depths of Planet 4546B!
      </li>
    </ul>
    <div className="subnautica-creatures-how-to-play__tip">
      <b>Tip:</b> After 5 attempts, you can reveal a description hint about the creature.
    </div>
  </>
);

const SubnauticaCreaturesHowToPlay = ({ show, onClose, gameId }) => {
  const { handleNewAchievements } = useAchievements();
  const { isAuthenticated } = useAuth();
  
  // Track when the modal is shown (only for authenticated users)
  useEffect(() => {
    if (show && gameId && isAuthenticated) {
      const trackGuideView = async () => {
        const response = await trackHowToPlayViewed(gameId);
        if (response && response.newAchievements && response.newAchievements.length > 0) {
          handleNewAchievements(response.newAchievements);
        }
      };
      trackGuideView();
    }
  }, [show, gameId, isAuthenticated, handleNewAchievements]);

  if (!show) return null;

  return (
    <div className="subnautica-creatures-how-to-play" onClick={onClose}>
      <div className="subnautica-creatures-how-to-play__panel" onClick={e => e.stopPropagation()}>
        <button className="subnautica-creatures-how-to-play__close-button" onClick={onClose}>
          ✕
        </button>
        <HowToPlayContent />
      </div>
    </div>
  );
};

export default SubnauticaCreaturesHowToPlay;